module.exports = __webpack_public_path__ + "static/media/faq-screenshot.fee3f021.png";